import styled from "styled-components";

import { TabList } from "@similarweb/ui-components";

import { TrendContainer } from "app/components/React/Table/cells/TrendCell";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const DrilldownWrapper = styled(FlexRow)`
    justify-content: space-between;
`;

export const StyledTrendContainer = styled(TrendContainer)`
    width: 70px;
`;

export const TabListStyled = styled(TabList)`
    margin-bottom: 24px;
`;
